import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormContext } from './FormContext';
import { Feedback } from './Feedback';
const Static = (props)=>{
    return /*#__PURE__*/ _jsx(FormControl, {
        componentClass: "p",
        ...props,
        plaintext: true
    });
};
// eslint-disable-next-line react/display-name
export const FormControl = /*#__PURE__*/ React.forwardRef(({ type, bsSize, htmlSize, id, className, isSuccess = false, isWarning = false, isError = false, plaintext, readOnly, icon, componentClass: Component = 'input', ...props }, ref)=>{
    const { controlId, validationState } = useContext(FormContext);
    const bsPrefix = Component === 'select' ? 'form-select' : 'form-control';
    let classes;
    if (plaintext) {
        classes = {
            [`${bsPrefix}-plaintext`]: true
        };
    } else if (type === 'range') {
        classes = {
            ['form-range']: true
        };
    } else {
        classes = {
            [bsPrefix]: true,
            [`${bsPrefix}-${bsSize}`]: bsSize
        };
    }
    const success = isSuccess || validationState === 'success';
    const warning = isWarning || validationState === 'warning';
    const error = isError || validationState === 'error';
    const control = /*#__PURE__*/ _jsx(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: classNames(className, classes, success && 'is-success', error && 'is-error', warning && 'is-warning')
    });
    if (icon && Component === 'input' && !plaintext && type !== 'range' && type !== 'file') {
        return /*#__PURE__*/ _jsxs("div", {
            className: "input-icons",
            children: [
                /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                    icon: icon,
                    fixedWidth: true,
                    className: "input-icon"
                }),
                control
            ]
        });
    }
    return control;
});
FormControl.displayName = 'FormControl';
FormControl.Feedback = Feedback;
FormControl.Static = Static;
